import concat from 'lodash/concat';
import get from 'lodash/get';
import uniq from 'lodash/uniq';

export default function getAssignmentUserIds(assignment, orgGroups) {
  // Return unique list of users associated with an assignment
  let allUsers = [];
  allUsers = concat(allUsers, get(assignment, 'students.users') || []);
  const groups = get(assignment, 'students.groups') || [];
  groups.forEach((groupId) => {
    const group = orgGroups.find((grp) => grp._id === groupId);
    if (group) {
      allUsers = concat(allUsers, group.members);
    }
  });
  return uniq(allUsers);
}
